/**
 * Meses configurados para la navegación de MakeMake Live.
 *
 * Cada entrada define fecha base, nombre traducible y visibilidad.
 */
export const MAKEMAKE_LIVE_MONTHS = [
    {
        id: "enero",
        date: "2026-01-01",
        name: {
            default: "Enero",
            translationPath: "meses.enero",
        },
        visible: true,
    },
    {
        id: "febrero",
        date: "2026-02-01",
        name: {
            default: "Febrero",
            translationPath: "meses.febrero",
        },
        visible: true,
    },
    {
        id: "marzo",
        date: "2026-03-01",
        name: {
            default: "Marzo",
            translationPath: "meses.marzo",
        },
        visible: true,
    },
    {
        id: "abril",
        date: "2026-04-01",
        name: {
            default: "Abril",
            translationPath: "meses.abril",
        },
        visible: true,
    },
    {
        id: "mayo",
        date: "2026-05-01",
        name: {
            default: "Mayo",
            translationPath: "meses.mayo",
        },
        visible: true,
    },
    {
        id: "junio",
        date: "2026-06-01",
        name: {
            default: "Junio",
            translationPath: "meses.junio",
        },
        visible: true,
    },
    {
        id: "julio",
        date: "2026-07-01",
        name: {
            default: "Julio",
            translationPath: "meses.julio",
        },
        visible: true,
    },
    {
        id: "agosto",
        date: "2026-08-01",
        name: {
            default: "Agosto",
            translationPath: "meses.agosto",
        },
        visible: true,
    },
    {
        id: "septiembre",
        date: "2026-09-01",
        name: {
            default: "Septiembre",
            translationPath: "meses.septiembre",
        },
        visible: true,
    },
    {
        id: "octubre",
        date: "2026-10-01",
        name: {
            default: "Octubre",
            translationPath: "meses.octubre",
        },
        visible: true,
    },
    {
        id: "noviembre",
        date: "2026-11-01",
        name: {
            default: "Noviembre",
            translationPath: "meses.noviembre",
        },
        visible: true,
    },
    {
        id: "diciembre",
        date: "2026-12-01",
        name: {
            default: "Diciembre",
            translationPath: "meses.diciembre",
        },
        visible: true,
    },
];
